import React, { useState, useRef, useEffect } from "react"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import TextField from "@material-ui/core/TextField"
import Link from "@material-ui/core/Link"
import Button from "@material-ui/core/Button"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from "@material-ui/core/FormHelperText"
import { Typography, Grid } from "@material-ui/core"
import NumberFormat from "react-number-format"
import DialogAviso from "../DialogTerminos";

const StyledButton = withStyles({
  root: {
    background: "white",
    borderRadius: "27px",
    border: 0,
    color: "#385099",
    height: 48,
    width: "320px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
    "@media (max-width: 720px)": {
      height: 48,
      width: "90%",
    },
  },
  label: {
    textTransform: "none",
    font: "400 17px/20px Montserrat",
  },
})(Button)

const StyledButtonSig = withStyles({
  root: {
    background: "linear-gradient(90deg, #CFF31B 0%, #16B1CB 100%)",
    borderRadius: "27px",
    border: 0,
    color: "white",
    height: 48,
    width: "194px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
    "@media (max-width: 720px)": {
      height: 48,
      width: "194px",
    },
  },
  label: {
    textTransform: "none",
    fontFamily: "Helvetica",
    fontSize: "27px",
    font: "800 22px/27px Montserrat",
  },
})(Button)

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    width: "90%",
    marginLeft: "4rem",
    marginTop: "1rem",
    marginBottom: "2rem",
    boxShadow: "none",
    "@media (max-width: 720px)": {
      width: "100%",
      marginLeft: "0",
      display: "flex",
      justifyContent: "center",
    },
  },
  Logo: {
    maxHeight: 100,
    maxWidth: 180,
  },
  title: {
    color: "#003CAE",
    fontSize: 35,
    marginBottom: 10,
  },
  bodyOfText: {
    color: "#959595",
    fontSize: 17,
    margin: 0,
  },
  TextInput: {
    marginTop: "0.5rem",
    width: "100%",
  },
  Link: {
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 15,
  },
  LinkIcon: {
    marginRight: 5,
  },
  centeredButton: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  disabledButton: {
    backgroundColor: "#666",
    borderRadius: 20,
    textTransform: "none",
    fontWeight: 600,
    marginTop: 30,
    width: 100,
    fontSize: 12,
  },
  mainButton: {
    backgroundColor: "#009FAE",
    borderRadius: 20,
    textTransform: "none",
    fontWeight: 600,
    marginTop: 30,
    width: 100,
    fontSize: 12,
  },
  Hidden: {
    display: "none",
  },
  radioGroup: {
    marginTop: "40px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop:'-2rem',
    "@media (max-width: 320px)": {
      paddingLeft: "2rem",
    },
  },
  helperText: {
    color: "red",
  },
  TextSecondary: {
    color: "#4D4F5C",
    marginLeft: "1rem",
    font: "400 13px/20px Montserrat",
    marginTop: "0rem",
  },
  Parrafofotter: {
    font: "400 13px/21px Montserrat",
    textAlign: "left",
    color: "#385099",
    marginTop: "-2rem",
  },
  Privacidad: {
    // marginLeft: "2.3rem",
    marginTop:'-2rem',
  },
  LabelCheck: {
    marginTop: "0.5rem",
    cursor: "pointer",
    textDecoration: "underline",
  },
  LabelCheckError: {
    marginTop: "0.5rem",
    cursor: "pointer",
    textDecoration: "underline",
    color: "red",
  },
  containerInputs: {
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    "@media (max-width: 720px)": {
      justifyContent: "center",
    },
  },
})

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props


  return (
    <NumberFormat
      {...other}
      maxLength="10"
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      isNumericString
    />
  )
}

function CustomCard(props) {
  const { employees, price, ChangePage, registerCompany } = props
  const companyLogoRef = useRef(null)
  const classes = useStyles()

  const [nombre, setNombre] = useState("")
  const [nombreError, setNombreError] = useState(false)
  const [razonSocial, setRazonSocial] = useState("")
  const [razonSocialError, setRazonSocialError] = useState(false)
  const [correoEmpresa, setCorreoEmpresa] = useState("")
  const [correoEmpresaConfirm, setcorreoEmpresaConfirm] = useState("")
  const [correoEmpresaError, setCorreoEmpresaError] = useState(false)
  const [telefono, setTelefono] = useState("")
  const [telefonoError, setTelefonoError] = useState(false)
  const [AvisoPrivacidad, setAvisoPrivacidad] = useState(false)
  const [AvisoPrivacidadError, setAvisoPrivacidadError] = useState(false)
  const [tipoEmpresa, setTipoEmpresa] = useState("")
  const [logo, setLogo] = useState("")
  const [errorLogo, setErrorLogo] = useState("")
  const [helperTextCompany, setHelperTextCompany] = useState("")
  const [ErrorConfirmText, setErrorConfirmText] = useState("")
  const [extension, setExtension] = useState("")
  const [correoConfirmError, setcorreoConfirmError] = useState(false)

  const handleUploadFile = event => {
    let selectedFile = event.target.files
    let file = null
    const extension = event.target.files[0].type.replace("image/", "")
    setExtension(extension)
    if (selectedFile.length > 0) {
      let fileToLoad = selectedFile[0]
      let fileReader = new FileReader()
      fileReader.onload = function(fileLoadedEvent) {
        file = fileLoadedEvent.target.result
        const tipeB64 = file.split(",")
        const fileB64 = file.replace(`${tipeB64[0]},`, "")
        setLogo(fileB64)
      }
      fileReader.readAsDataURL(fileToLoad)
    }
  }

  const verifyEmail = value => {
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (emailRex.test(value)) {
      return true
    }
    return false
  }

  const verifyLength = (value, length, opt) => {
    if (opt !== undefined) {
      if (value.length === length) {
        return true
      }
      return false
    }

    if (value.length >= length) {
      return true
    }
    return false
  }

  const validate = () => {
    if (
      verifyLength(nombre, 3) &&
      verifyEmail(correoEmpresa) &&
      verifyLength(razonSocial, 3) &&
      verifyLength(telefono, 10) &&
      verifyLength(tipoEmpresa, 1) &&
      AvisoPrivacidad === true &&
      logo !== "" &&
      verifyEmail(correoEmpresaConfirm)
    ) {
      setNombreError(!verifyLength(nombre, 3) ? true : false)
      setCorreoEmpresaError(!verifyEmail(correoEmpresa) ? true : false)
      setRazonSocialError(!verifyLength(razonSocial, 3) ? true : false)
      setTelefonoError(!verifyLength(telefono, 10) ? true : false)
      setcorreoConfirmError(
        !verifyEmail(correoEmpresaConfirm) &&
          correoEmpresa !== correoEmpresaConfirm
          ? true
          : false
      )
      setAvisoPrivacidadError(AvisoPrivacidad ? false : true)
      setHelperTextCompany(
        !verifyLength(tipoEmpresa, 1) ? "Selecciona el tipo de empresa" : ""
      )
      setErrorLogo(!verifyLength(logo, 1) ? "Carga un logo" : "")
      return true
    } else {
      setNombreError(!verifyLength(nombre, 3) ? true : false)
      setCorreoEmpresaError(!verifyEmail(correoEmpresa) ? true : false)
      setRazonSocialError(!verifyLength(razonSocial, 3) ? true : false)
      setTelefonoError(!verifyLength(telefono, 10) ? true : false)
      setHelperTextCompany(
        !verifyLength(tipoEmpresa, 1) ? "Selecciona el tipo de empresa" : ""
      )
      setAvisoPrivacidadError(AvisoPrivacidad ? false : true)
      setErrorLogo(!verifyLength(logo, 1) ? "Selecciona el logo" : "")
      setErrorConfirmText(
        correoEmpresaConfirm === correoEmpresa
          ? ""
          : "El correo electrónico no coincide"
      )
      return false
    }
  }

  const clickRegister = async () => {
    if (validate()) {
      const dataCompany = {
        nombre,
        razonSocial,
        correoEmpresa,
        telefono,
        numeroEmpleados: employees,
        extension,
        logo,
        monto: 1, //parseInt(price),
        tipoEmpresa,
      }
      registerCompany(dataCompany)
    }
  }

  const validateMail = (e, confirm) => {
    if (/^([ a-z 0-9 @ .])*$/.test(e.target.value)) {
      if (confirm) {
        setcorreoEmpresaConfirm(e.target.value)
      } else {
        setCorreoEmpresa(e.target.value)
      }
    }
  }


  return (
    <Card className={classes.root}>
      <Grid container spacing={3} xs={12} className={classes.containerInputs}>
        <Grid item xs={11} md={4}>
          <TextField
            className={classes.TextInput}
            label="Nombre completo"
            type="text"
            variant="outlined"
            error={nombreError}
            onChange={e => setNombre(e.target.value)}
            inputProps={{ maxLength: 250 }}
          />
        </Grid>
        <Grid item xs={11} md={4}>
          <TextField
            className={classes.TextInput}
            label="Correo electrónico"
            type="email"
            variant="outlined"
            error={correoEmpresaError}
            value={correoEmpresa}
            onChange={e => validateMail(e)}
            inputProps={{ maxLength: 250 }}
          />
        </Grid>
        <Grid item xs={11} md={4}>
          <TextField
            className={classes.TextInput}
            label="Confirmar correo electrónico"
            type="email"
            variant="outlined"
            error={correoConfirmError}
            value={correoEmpresaConfirm}
            onChange={e => validateMail(e, "confirm")}
            inputProps={{ maxLength: 250 }}
          />
          <FormHelperText className={classes.helperText}>
            {ErrorConfirmText}
          </FormHelperText>
        </Grid>
        <Grid item xs={11} md={4}>
          <TextField
            className={classes.TextInput}
            label="Razón social"
            type="text"
            variant="outlined"
            color="primary"
            error={razonSocialError}
            onChange={e => setRazonSocial(e.target.value)}
            inputProps={{ maxLength: 250 }}
          />
        </Grid>
        <Grid item xs={11} md={4}>
          <TextField
            className={classes.TextInput}
            label="Teléfono"
            variant="outlined"
            maxLength="10"
            error={telefonoError}
            onChange={e => setTelefono(e.target.value)}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </Grid>
        <Grid item xs={11} md={4} />
        <Grid container xs={12} md={4} className={classes.radioGroup}>
          <RadioGroup
            row
            aria-label="gender"
            name="gender1"
            //value={value}
            onChange={e => setTipoEmpresa(e.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Una empresa"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Grupo de empresas"
            />
          </RadioGroup>
          <FormHelperText className={classes.helperText}>
            {helperTextCompany}
          </FormHelperText>
        </Grid>
        <Grid
          item
          xs={11}
          md={4}
          container
          direction="column"
          justify="center"
          alignItems="center"
        >
          <Link
            className={classes.Link}
            onClick={() => companyLogoRef.current.click()}
          >
            <StyledButton>Seleccionar imagen de logo</StyledButton>
          </Link>
          <FormHelperText className={classes.helperText}>
            {errorLogo}
          </FormHelperText>
          <Typography className={classes.TextSecondary}>Max. 2MB</Typography>
          <input
            type="file"
            ref={companyLogoRef}
            className={classes.Hidden}
            onChange={e => handleUploadFile(e)}
          />
        </Grid>
        <Grid md={4} />
        <Grid
          container
          xs={12}
          md={4}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.Privacidad}
        >
          <Checkbox
            checked={AvisoPrivacidad}
            onChange={() => setAvisoPrivacidad(!AvisoPrivacidad)}
            color="primary"
            inputProps={{ "aria-label": "secondary checkbox" }}
          />
          <Typography
            className={
              AvisoPrivacidadError
                ? classes.LabelCheckError
                : classes.LabelCheck
            }
          >
            <DialogAviso type="Compra"/>
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.centeredButton}>
          {/* <StyledButtonSig onClick={() => ChangePage()} id="COMPRA 1">
            Siguiente
          </StyledButtonSig> */}
          <StyledButtonSig onClick={() => clickRegister()} id="COMPRA 1">
            Siguiente
          </StyledButtonSig>
        </Grid>

        <Grid item xs={12}>
          <p className={classes.Parrafofotter}>
            Si desea generar factura, envíe sus datos fiscales, incluyendo razón
            social, a la dirección electrónica facturacion@springlabs.net El
            pago puede tardar hasta 24 horas en verse reflejado en nuestro
            sistema.
          </p>
        </Grid>
      </Grid>
    </Card>
  )
}

export default CustomCard
